import React, { useEffect, useState } from 'react';
import MainLayout from '../layouts/MainLayout';
import userpanelService from '../services/userpanel/userpanel.service';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import moment from 'moment';
import { grey } from '@mui/material/colors';
import { relative } from 'path';
const ContrastColor = require('contrast-color');


function Home() {

  //var usersdata: any[] = []
  const [usersdata, setUserData] = useState([]);
  const [notedata, setNoteData] = useState([]);
  const [contractorsdata, setContractorsData] = useState([]);

  const [usersContractorsData, setUsersContractorsData] = useState([]);

  const [user_id, setUserID] = useState(0);

  const [summarydata, setSummaryData] = useState({today_notes_count: 0, today_contractors_add:0});


  function chooseUserID(user_id : number){
    if (user_id > 0){
      userpanelService.getusercontractorsdata(user_id).then(response => {
        console.log(response)
        setUsersContractorsData(response.items); 
      })

      setUserID(user_id)
    }else{
      setUserID(0)
    }
  }
      
  useEffect(()=>{
    document.body.classList.add('boverride')

    userpanelService.getusersdata().then(response => {
      //console.log(response)
    setUserData(response)
    
  })

  

  userpanelService.getcontractorsdata().then(response => {
    //console.log(response)
    //console.log(moment(response.items[0].created).format('D-MM-YYYY'))
  setContractorsData(response.items)
  
})

  

  userpanelService.getsummarydata().then(response => {
  //  console.log(response)
    setSummaryData(response)
  
})

  userpanelService.getnotedata().then(response => {
   // console.log(response)
    setNoteData(response.items)
  
})

  }, [])
  
  
  return (
    <div>
      {/* Content Wrapper. Contains page content */}
      <div id="smaller-container" style={{ width: '100%' }}>
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Panel użytkownika</h1>
              </div>{/* /.col */}
              
            </div>{/* /.row */}
          </div>{/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            {/* Small boxes (Stat box) */}
            <div className="row">
            {usersdata.map((data) =>
    
              <div key={data['id']} className="col-lg-3 col-6">
                {/* small box */}
                <div className="small-box bg-warning">
                  <div className="inner">
                    <OverlayTrigger 
                      delay={{ hide: 450, show: 300 }}
                      overlay={(props) => (
                        <Tooltip {...props}>
                          Liczba kontrahentów z dzisiaj:
                          (do obsłużenia / obsłużone)
                        </Tooltip>
                      )}
                      placement="bottom">            
                      
                      <h3  style={{marginTop:0}}>
                    
                  {data['today_todo_contacts_count']}/{data['today_done_contacts_count']}
                  </h3>
                  </OverlayTrigger>
                  <br/>
                  <OverlayTrigger 
                      delay={{ hide: 450, show: 300 }}
                      
                      overlay={(props) => (
                        <Tooltip {...props}>
                          Liczba kontrahentów z tego tygodnia:
                          (do obsłużenia / obsłużone)
                        </Tooltip>
                      )}
                      placement="bottom">  
                    <h3 >{data['thisweek_todo_contacts_count']}/{data['thisweek_done_contacts_count']}</h3>
                    </OverlayTrigger>
                    <p>{data['firstname']} {data['surname']}</p>
                  </div>
                  <div className="icon">
                 
                    <span style={{position:'absolute', right:15, top:15, backgroundColor:data['color'], color:new ContrastColor(data['color'])}} className="gavatar_l" >{data['shortcut']}</span>
                
                  </div>
                  <a href="#" onClick={()=>chooseUserID(data['id'])} className="small-box-footer">Więcej informacji <i className="fas fa-arrow-circle-right" /></a>
                </div>
              </div>
            )  
            }
              
            </div>
            {/* /.row */}
            {/* Main row */}
            <div className="row">
              {/* Left col */}
              <section className=" connectedSortable">
                {/* Custom tabs (Charts with tabs)*/}
                
               {user_id > 0 ?  <div className="card direct-chat direct-chat-primary">
                  <div className="card-header">
                    <h3 className="card-title">{usersContractorsData.length > 0 ? usersContractorsData[0]['firstname'] : " "} {usersContractorsData.length > 0 ? usersContractorsData[0]['surname'] : " "}</h3>
                    <div className="card-tools">
                      <span title={(summarydata['today_contractors_add']).toString() + " z dzisiaj"} className="badge badge-primary">{summarydata['today_contractors_add']}</span>
                      <button type="button" className="btn btn-tool" data-card-widget="collapse">
                        <i className="fas fa-minus" />
                      </button>
                      
                      <button type="button" className="btn btn-tool" data-card-widget="remove">
                        <i className="fas fa-times" />
                      </button>
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    <div className="card">
                     
                      {/* /.card-header */}
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table m-0">
                            <thead>
                              <tr>
                                <th>Status</th>
                                <th>Wszyscy</th>
                                <th>Z dzisja do zrobienia</th>
                                <th>Z dzisja zrobione</th>
                                <th>Z tego tygodnia do zrobienia</th>
                                <th>Z tego tygodnia zrobione</th>
                              </tr>
                            </thead>
                            <tbody>
                            {usersContractorsData.map((data) => <tr>
                                <td>{data['state_name']}</td>
                                <td>{data['total_count']}</td>
                                <td>{data['today_todo_count']}</td>
                                <td>{data['today_done_count']}</td>
                                <td>{data['thisweek_todo_count']}</td>
                                <td>{data['thisweek_done_count']}</td>
                              </tr>
                            )
                          }
                            </tbody>
                          </table>
                        </div>
                        {/* /.table-responsive */}
                      </div>
                      
                    </div>

                  </div>
                 
                </div>
                  : ""
                }
                

                {/* /.card */}
                {/* DIRECT CHAT */}
                <div className="card direct-chat direct-chat-primary">
                  <div className="card-header">
                    <h3 className="card-title">Ostatnie notatki</h3>
                    <div className="card-tools">
                      <span title={(summarydata['today_notes_count']).toString() + " z dzisiaj"} className="badge badge-primary">{summarydata['today_notes_count']}</span>
                      <button type="button" className="btn btn-tool" data-card-widget="collapse">
                        <i className="fas fa-minus" />
                      </button>
                      
                      <button type="button" className="btn btn-tool" data-card-widget="remove">
                        <i className="fas fa-times" />
                      </button>
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    {/* Conversations are loaded here */}
                    <div className="direct-chat-messages">
                      {/* Message. Default to the left */}
                      {notedata.map((data) =>
                        <div style={{position:"relative"}} key={data['id']} className="direct-chat-msg">
                          <div className="direct-chat-infos clearfix">
                            <span className="direct-chat-name float-left">
                            <a className='slickRowLink' href={"/contractors/card/" + data['contractor_id']}> {data['contractor_name']} </a>, {data['notedef_name']}
                            </span>
                            <span className="direct-chat-timestamp float-right">{moment(data['created']).format("D-MM-YYYY HH:mm")}</span>
                          </div>
                          {/* /.direct-chat-infos */}
                          <span style={{ position:'absolute', left:-5, top:20, backgroundColor:data['color'] ? data['color'] : "grey" , color:new ContrastColor(data['color']? data['color'] : "grey")}} className="gavatar_l" >{data['shortcut']}</span>
                
                          {/* /.direct-chat-img */}
                          <div className="direct-chat-text">
                            {data['description']?data['description'] : '-' }
                          </div>
                          {/* /.direct-chat-text */}
                        </div>
                      )}
                    
                      
                     
                    </div>

                  </div>
                 
                </div>
                {/*/.direct-chat */}
                <div className="card direct-chat direct-chat-primary">
                  <div className="card-header">
                    <h3 className="card-title">Nowi kontrahenci</h3>
                    <div className="card-tools">
                      <span title={(summarydata['today_contractors_add']).toString() + " z dzisiaj"} className="badge badge-primary">{summarydata['today_contractors_add']}</span>
                      <button type="button" className="btn btn-tool" data-card-widget="collapse">
                        <i className="fas fa-minus" />
                      </button>
                      
                      <button type="button" className="btn btn-tool" data-card-widget="remove">
                        <i className="fas fa-times" />
                      </button>
                    </div>
                  </div>
                  {/* /.card-header */}
                  <div className="card-body">
                    {/* Conversations are loaded here */}
                    <div className="direct-chat-messages">
                      {/* Message. Default to the left */}
                      {contractorsdata.map((data) =>
                        <div style={{position:"relative"}} key={data['id']} className="direct-chat-msg">
                          <div className="direct-chat-infos clearfix">
                            <span className="direct-chat-name float-left">
                            <a className='slickRowLink' href={"/contractors/card/" + data['id']}> {data['shortname']} </a>, {data['trader_name']}
                            </span>
                            <span className="direct-chat-timestamp float-right">{moment(data['created']).format("D-MM-YYYY HH:mm")}</span>
                          </div>
                          {/* /.direct-chat-infos */}
                          <span style={{ position:'absolute', left:-5, top:20, backgroundColor:data['creator_color'] ? data['creator_color'] : "grey" , color:new ContrastColor(data['creator_color']? data['creator_color'] : "grey")}} className="gavatar_l" >{data['creator_shortcut']}</span>
                
                          {/* /.direct-chat-img */}
                          <div className="direct-chat-text">
                            {data['name']?data['name'] : '-' }
                          </div>
                          {/* /.direct-chat-text */}
                        </div>
                      )}
                    
                      
                     
                    </div>

                  </div>
                 
                </div>
                {/* /.card */}
              </section>
              {/* /.Left col */}

            </div>
            {/* /.row (main row) */}
          </div>{/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}

    </div>
  );
}

export default Home;